import { makeAutoObservable } from 'mobx'
// import { RootStore } from 'mobx-stores/root-store'
import { UserDTO, UserRoleDTO } from 'models'
import { Api, FetchOptions } from 'services'

export class UsersMainStore {
  private userApi: Api['userApi']

  constructor (rootStore: any) {
    this.userApi = rootStore.generalStore.api.userApi
    makeAutoObservable(this)
  }

  // OBSERVABLES
  private users: Map<string, UserDTO> = new Map()

  // ACTIONS
  private setUsers = (users: Map<string, UserDTO>): void => {
    this.users = users
  }

  // METHODS
  public clearStore = (): void => {
    this.setUsers(new Map())
  }

  public loadUsers = async (options?: FetchOptions): Promise<void> => {
    const usersList = await this.userApi.getAllUsers(options)
    if (!usersList) return

    const users = new Map(usersList.map(user => [user.emailAddress, user]))
    this.setUsers(users)
  }

  // public getUserById = (userId: number): UserDTO => {
  //   return this.users.get(userId)
  // }

  public getUserByEmailAddress = (emailAddress: string): UserDTO => {
    return this.users.get(emailAddress)
  }

  // COMPUTED
  public get usersList (): UserDTO[] {
    return Array.from(this.users.values())
  }

  private get usedUserRoles (): Map<number, UserRoleDTO> {
    const rolesMap: Map<number, UserRoleDTO> = new Map()
    this.usersList.forEach(({ role, roles = [] }) => {
      role && rolesMap.set(role.id, role)
      roles.forEach(r => {
        rolesMap.set(r.id, r)
      })
    })
    return rolesMap
  }

  public get usedUserRolesList (): UserRoleDTO[] {
    return Array.from(this.usedUserRoles.values())
  }
}
